import { Message } from 'element-ui';
import * as signalR from '@aspnet/signalr';

export default{
    data() {
        return {
            transactionConnection: null,
            commonConnection: null,
            addedEvent: '',
            updatedEvent: '',
            processingEvent: '',
            doneEvent: ''
        }
    },
    methods: {
        successMessage(message) {
            this.$message({
                showClose: true,
                duration: 3000,
                message: message,
                type: 'success'
            });
        },
        errorMessage(message) {
            this.$message({
                showClose: true,
                duration: 3000,
                message: message,
                type: 'error'
            });
        },
        infoMessage(message) {
            this.$message({
                showClose: true,
                duration: 3000,
                message: message,
                type: 'info'
            });
        },
        warningMessage(message) {
            this.$message({
                showClose: true,
                duration: 3000,
                message: message,
                type: 'warning'
            });
        },

        successMessageBox(message, title) {
            this.$confirm(message, title, {
              confirmButtonText: 'OK',
              showCancelButton: false,
              type: 'success',
              center: true
            }).then(() => {
            }).catch(() => {
            });
          },
          errorMessageBox(message, title) {
            this.$confirm(message, title, {
              confirmButtonText: 'OK',
              showCancelButton: false,
              type: 'error',
              center: true
            }).then(() => {
            }).catch(() => {
            });
          },
          infoMessageBox(message, title) {
            this.$confirm(message, title, {
              confirmButtonText: 'OK',
              showCancelButton: false,
              type: 'info',
              center: true
            }).then(() => {
            }).catch(() => {
            });
          },
          warningMessageBox(message, title) {
            this.$confirm(message, title, {
              confirmButtonText: 'OK',
              showCancelButton: false,
              type: 'warning',
              center: true
            }).then(() => {
            }).catch(() => {
            });
          },
          startTimer() {
            const updateTimer = () => {
              const timeNow = new Date().getTime();
              const timeDifference = this.countDownToTime - timeNow;

              if (timeDifference <= 0) {
                this.timerOutput = 'Time is up!';
                this.showTimer = false;
                return;
              }

              const millisecondsInOneSecond = 1000;
              const millisecondsInOneMinute = millisecondsInOneSecond * 60;
              const millisecondsInOneHour = millisecondsInOneMinute * 60;
              const millisecondsInOneDay = millisecondsInOneHour * 24;

              const remainingDays = Math.floor(timeDifference / millisecondsInOneDay);
              const remainingHours = Math.floor((timeDifference % millisecondsInOneDay) / millisecondsInOneHour);
              const remainingMinutes = Math.floor((timeDifference % millisecondsInOneHour) / millisecondsInOneMinute);
              const remainingSeconds = Math.floor((timeDifference % millisecondsInOneMinute) / millisecondsInOneSecond);

              this.timerOutput = `${remainingDays} Days : ${remainingHours} Hours : ${remainingMinutes} Minutes : ${remainingSeconds} Seconds`;
            };

            updateTimer(); // Initial call to set the timer immediately
            setInterval(updateTimer, 1000); // Update the timer every second
          },
          transactionAddedEvent(){
            // this.transactionConnection.invoke("TransactionAddedAsync").catch(err => console.error(err.toString()));
          },
          transactionUpdatedEvent(transaction) {
            // this.transactionConnection.invoke("TransactionUpdatedAsync",
            // transaction.id, transaction.referenceNumber, this.loggedInUser).catch(err => console.error(err.toString()));
          },
          processActiveEvent(message) {
            // this.commonConnection.invoke("ProcessingAsync", `${message} by ${this.loggedInUser}`).catch(err => console.error(err.toString()));
          },
          doneActiveEvent(message) {
            // this.commonConnection.invoke("DoneAsync", `${message} by ${this.loggedInUser}`).catch(err => console.error(err.toString()));
          }
    },
    created() {
        let self = this;
        //this.getUserName();
    }
};